module Environments {
    module.directive("agentnameunique", [
        "$http",
        "BootstrapDataService",
        function ($http, bootstrapDataService) {
            return {
                require: "ngModel",
                link: function (scope, element, attributes, control) {
                    var agentGroup = scope.agentGroup;
                    var environment = scope.environment;
                    element.on("blur", function () {
                        $http({
                            url: bootstrapDataService.checkAgentNameUrl,
                            method: "GET",
                            params: {
                                agentName: element.val(),
                                environmentName: environment.name,
                                agentGroupName: agentGroup.name
                            }
                        }).then(function (response) {
                            if (response.data && response.data.success) {
                                var agentNameInUse = response.data.data;
                                control.$setValidity("agentnameunique", !agentNameInUse); // remove/add agent name unique error
                            }
                        });
                    });
                    element.on("input", function () {
                        scope.$apply(function () {
                            control.$setValidity("agentnameunique", true); // remove agent name unique error
                        });
                    });
                }
            };
        }
    ]);
}